import { render, staticRenderFns } from "./TKLogView.vue?vue&type=template&id=3598a2aa&scoped=true&"
import script from "./TKLogView.vue?vue&type=script&lang=ts&"
export * from "./TKLogView.vue?vue&type=script&lang=ts&"
import style0 from "./TKLogView.vue?vue&type=style&index=0&id=3598a2aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598a2aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
